module.exports = __webpack_public_path__ + "static/img/buddy_mini_pictgrid4_800x606.7976989.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_mini_pictgrid4_800x606.jpg
// module id = 5pXY
// module chunks = 0